import { getLanguageIso2 } from '../modules/i18n';

const languageIso2 = getLanguageIso2();

document.addEventListener('jb-video:connected', async (event: Event) => {
  const { element } = (event as CustomEvent).detail;
  element.defaultCaptionsLanguage = await languageIso2;
});
